module.exports = __webpack_public_path__ + "img/u1185.1e0bf280.svg";